module.exports = __webpack_public_path__ + "media/warranty-claim/affected-6787c0dc.svg";